export default __webpack_public_path__ + "static/media/886.b85b258c.png";